import React, {useState, useEffect, useRef} from "react";
import styles from './filter.module.css'
import ChevronDownSVG from "../../images/chevronDown.svg";
import {Button, FormCheck} from "react-bootstrap";
import '../../App.css'

function useComponentVisible(initialIsVisible) {

    const [showFilter, setShowFilter] = useState(
        initialIsVisible
    );
    const ref = useRef(null);

    const handleHideDropdown = (event) => {
        if (event.key === "Escape") {
            setShowFilter(false);
        }
    };

    const handleClickOutside = event => {
        if (ref.current && !ref.current.contains(event.target)) {
            setShowFilter(false);
        }
    };

    useEffect(() => {
        document.addEventListener("keydown", handleHideDropdown, true);
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("keydown", handleHideDropdown, true);
            document.removeEventListener("click", handleClickOutside, true);
        };
    });

    return {ref, showFilter, setShowFilter};
}

const Filter = ({filter, manageFilterItem, aplicarFiltros, limpiarFiltrosProps}) => {
    const [opciones, setOpciones] = useState([])
    const [click, setClick] = useState(0)

    useEffect(() => {
        setOpciones(filter.opciones.map(o => ({nombre: o.nombre, checked: false})))
    }, [filter])

    const manageElement = (opcion) => {
        manageFilterItem(filter.nombre, opcion)
        const opcionesAux = opciones.map(o => {
            if (o.nombre === opcion) {
                o.checked = !o.checked
            }
            return o
        })
        setOpciones(opcionesAux)
    }

    const limpiarFiltros = () => {
        limpiarFiltrosProps(filter.nombre)
        setOpciones(opciones.map(o => ({nombre: o.nombre, checked: false})))
    }

    const apply = () => {
        aplicarFiltros()
        setShowFilter(false)
    }

    const handleClick = () => {
        console.log('click',click)
        if(click == 0){
            setShowFilter(true);
            setClick(1);
        }else{
            setShowFilter(false);
            setClick(0);
        }
    }


    const {
        ref,
        showFilter,
        setShowFilter
    } = useComponentVisible(false);
    return (
        <div className={`${styles.filterContainer}`} key={filter}>
            <button onClick={e => handleClick()}
                    className={`m-lg-auto my-2 py-1 px-3 ${styles.filterBtn} ${showFilter ? styles.openFilter : ''}`}>
                <div className={`d-flex flex-row align-items-center`}>
                    <p className={`m-auto text-dark`}>{filter.nombre}</p>
                    <img src={ChevronDownSVG} alt='chevrongDown'
                         className={`${styles.chevronDown}`}/>
                </div>
            </button>
            <div ref={ref} className={`${styles.modalFilter} ${showFilter ? 'd-block' : 'd-none'}`}
                 style={{zIndex: filter.id}}>
                <div className={styles.options}>
                    {opciones.length > 0 ?
                        opciones.map((opcion) => {
                                return <div key={opcion.nombre} className={`text-body ${styles.checkFilter} ${opcion.checked? "fw-bold" : ""} filters`}>
                                    <FormCheck id={'check-' + opcion.nombre} label={opcion.nombre}
                                               onChange={() => manageElement(opcion.nombre)}
                                               checked={opcion.checked} color={"blue"}/>
                                </div>
                            }
                        )
                        : null}
                </div>
                <hr/>
                <div className={`d-flex flex-row align-items-center justify-content-around ${styles.footerFilter}`}>
                    <a className={styles.limpiarFiltros} onClick={limpiarFiltros}>Limpiar filtros</a>
                    <Button variant="dark" className={styles.btnAplicar} onClick={apply}>Aplicar</Button>
                </div>
            </div>
        </div>
    );
};

export default Filter;
